import { Box3, BufferGeometry, Sphere, Vector3 } from "three";

const HUGE = 1e10;
const HUGE_BOX = new Box3(
  new Vector3(-HUGE, -HUGE, -HUGE),
  new Vector3(HUGE, HUGE, HUGE),
);
const HUGE_SPHERE = new Sphere(new Vector3(0, 0, 0), HUGE);

export function makePointsGeo(): BufferGeometry {
  const geo = new BufferGeometry();
  geo.boundingBox = HUGE_BOX.clone();
  geo.boundingSphere = HUGE_SPHERE.clone();
  geo.computeBoundingBox = () => {};
  geo.computeBoundingSphere = () => {};
  return geo;
}
